<template>
    <ul class="steps steps-4">
        <li
            v-for="(step, i) in steps"
            @click="handleClick(i)"
            :class="{ current: active == i, completed: active > i }"
        >
            <a>
                <em>Step {{ i + 1 }}</em>
                <span>{{ step }}</span>
            </a>
        </li>
    </ul>
</template>

<script>
export default {
    name: "Breadcrumb",
    props: ["steps", "active"],
    methods: {
        /**
         * Trigger the onNavigate prop if the step clicked on was completed
         * @param {String} i The index of the step clicked on
         * @return {Void}
         */
        handleClick(index) {
            if (this.active > index) {
                this.$emit("onNavigate", index);
            }
        },
    },
};
</script>

<style scoped>
.steps {
    margin: 40px auto;
    padding: 0;
    overflow: hidden;
    font-size: 0.9em;
}
.steps a,
.steps a:hover {
    color: white;
    text-decoration: none;
}

.steps em {
    display: block;
    font-size: 1.3em;
    font-weight: bold;
    font-style: initial;
    margin-bottom: 3px;
}
.steps li {
    cursor: pointer;
    float: left;
    margin-left: 0;
    height: 80px; /* height of breadcrumbs */
    list-style-type: none;
    padding: 12px 30px;
    padding-left: 50px;
    border-right: 3px solid white; /* gap between arrows, color: background of document */
    position: relative;
}
.steps li:first-child {
    padding-left: 30px;
}
.steps li:nth-child(n + 2)::before {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    border-left: 25px solid white;
    border-top: 40px solid transparent; /* half height of arrow */
    border-bottom: 40px solid transparent;
    width: 0;
    height: 0;
    content: " ";
}
.steps li::after {
    z-index: 1;
    position: absolute;
    top: 0;
    right: -25px;
    display: block;
    border-left: 25px solid #222e40;
    border-top: 40px solid transparent; /* half height of arrow */
    border-bottom: 40px solid transparent;
    width: 0;
    height: 0;
    content: " ";
}
/* Completed */
.steps li {
    background-color: #222e40;
}
.steps li::after {
    border-left-color: #222e40;
}
/* Current */
.steps li.current {
    background-color: #d64571;
}
.steps li.current::after {
    border-left-color: #d64571;
}
/* Following */
.steps li.current ~ li {
    background-color: #ebebeb;
}
.steps li.current ~ li a {
    color: black;
}
.steps li.current ~ li::after {
    border-left-color: #ebebeb;
}
</style>
